<script>
import Textarea from "@/pages/components/form/horizontal/textarea.vue";

export default {
  components: {Textarea},
  inheritAttrs: false,
  emits: ['update:modelValue'],
  props: {
    'modelValue': {
      required: true,
    },
    'name': {
      required: true,
      type: String,
    },
    'label': {
      required: true,
      type: String,
    },
    'required': {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<template>
  <Textarea
      v-bind="$attrs"
      :name="name"
      :label="label"
      :model-value="modelValue"
      :required="required"
      @update:modelValue="this.$emit('update:modelValue', $event)"
  />
</template>